var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholderImg",style:({height: _vm.imgType=='dialogForm'?'100px':'150px'})},[_c('img',{attrs:{"src":_vm.imgUrl,"width":"100"}})])}
var staticRenderFns = []

export { render, staticRenderFns }